// module.environment-outlook (contract §4.8.1): EnvironmentOutlookModule
// (modules.tsx): the wind and the headline temperature as a pair of large
// readouts with their gust and 3 h change, the headline's 24 h trend as a lane
// of its own, the second line of other temperatures, and the barometer's
// footer row (its 3 h change and tendency, or its value while the trend
// builds; none when the board has its own pressure module, ADR 0181).

import { css, h, rangeChip } from "./kit.js";
import { F, R, S } from "./module-kit.js";

const big = (label, value, unit, sub) =>
  h(
    "div",
    { class: "rd" },
    h("span", { class: "rd-l", ...F(label) }),
    h(
      "span",
      { class: "rd-row rd-lg" },
      h("span", { class: "rd-v", ...F(value) }),
      h("span", { class: "rd-u", ...F(unit) }),
    ),
    h("span", { class: "mo-sub", ...F(sub) }),
  );

export function moduleEnvironmentOutlook() {
  const subs = [0, 1].map((k) =>
    h(
      "span",
      { class: "en-s" },
      h("span", { class: "en-sl", ...R("sub-label", k) }),
      " ",
      h("b", R("sub-value", k)),
      h("span", { class: "en-su", ...R("sub-unit", k) }),
    ),
  );
  return {
    lane: true,
    kind: true,
    html: [
      h(
        "div",
        { class: "en-h" },
        big("wind-label", "wind", "wind-unit", "gust"),
        big("headline-label", "headline", "headline-unit", "headline-delta"),
      ),
      h("div", { class: "mo-rc" }, rangeChip()),
      h(
        "svg",
        {
          class: "mo-lane en-lane",
          "data-tc-fit": "lane",
          "aria-hidden": "true",
        },
        h("path", {
          class: "ar",
          ...S("headline", {
            "data-tc-shape": "area",
            "data-tc-inset": "3 1 3 1",
          }),
        }),
        h("path", {
          class: "ln",
          ...S("headline", { "data-tc-inset": "3 1 3 1" }),
        }),
      ),
      h("p", { class: "en-sub" }, subs),
      h("i", { class: "mo-flag", ...F("baro") }),
      h(
        "div",
        { class: "en-b" },
        h("span", { class: "en-bl" }, "Barometer"),
        h(
          "span",
          { class: "en-bd" },
          h("span", { class: "mo-g en-g", ...F("baro-glyph") }),
          h("span", F("baro-rate")),
          h("i", F("baro-rate-unit")),
        ),
        h(
          "span",
          { class: "en-bc" },
          h("span", F("baro-now")),
          h("span", { class: "en-sep" }, " · "),
          h("span", F("baro-label")),
        ),
      ),
    ],
    css: css(`
      .mo-environment-outlook { min-height: 0; }
      .en-h { display: grid; grid-template-columns: repeat(auto-fit, minmax(105px, 1fr)); gap: 4px 14px; flex: none; }
      .en-h .rd-v[data-quality=missing] { display: inline; }
      .en-h .mo-sub { font-size: 12.5px; font-variant-numeric: tabular-nums; }
      .en-lane { margin-top: 8px; }
      .en-sub { margin: 6px 0 0; font-size: 12px; color: var(--muted); font-variant-numeric: tabular-nums; flex: none; }
      .en-sub b { color: var(--muted); font-weight: 500; }
      .en-s + .en-s::before { content: "·"; margin: 0 6px; color: var(--quiet); }
      .en-sl:empty, .en-sl:empty ~ * { display: none; }
      .en-su:not(:empty) { margin-left: 0.25em; }
      .en-b { display: flex; align-items: baseline; justify-content: space-between; gap: 8px; flex: none;
        margin-top: 7px; padding-top: 7px; border-top: 1px solid var(--grid); }
      .en-bl { font-size: 12px; font-weight: 500; color: var(--muted); }
      .en-bd { font-size: 15px; font-weight: 500; color: var(--text); font-variant-numeric: tabular-nums; white-space: nowrap; }
      .en-bd i { font-style: normal; font-size: 11px; font-weight: 400; color: var(--muted); }
      .en-g { margin-right: 4px; color: var(--muted); }
      .en-bc { font-size: 11.5px; color: var(--muted); font-variant-numeric: tabular-nums; text-align: right; }
      .en-sep { display: none; }
      .mo-flag[data-state=on] ~ .en-b .en-sep { display: inline; }
      .mo-flag[data-state=off] ~ .en-b { display: none; }
      /* The bento's cell: the headline pair side by side down to the
         narrowest rail. */
      html[data-slot=environment-outlook] .en-h { grid-template-columns: repeat(auto-fit, minmax(92px, 1fr)); gap: 8px 16px; }
      html[data-slot=environment-outlook] .rd-l { font-size: 12px; }
    `),
  };
}
